module.exports = __webpack_public_path__ + "img/regiter-icon01.8b66c200.png";